import { FeatureConfiguration } from "..";
import { PagePositionReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.pagePosition = PagePositionReducer;
}
